var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6552 2.935C19.2452 3.525 19.2452 4.475 18.6552 5.055L14.7652 8.945L16.8852 18.135L15.4752 19.555L11.5952 12.125L7.69516 16.025L8.05516 18.495L6.98516 19.555L5.22516 16.375L2.03516 14.605L3.09516 13.525L5.59516 13.895L9.46516 10.025L2.03516 6.115L3.45516 4.705L12.6452 6.825L16.5352 2.935C17.0952 2.355 18.0952 2.355 18.6552 2.935Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.47bd53aa049faf6c0225dfe7e882f64c.svg";
export { ForwardRef as ReactComponent };